import { useMutation, useQuery, useQueryClient } from 'react-query';
import {
  DepartmentEmployeeApi,
  DepartmentEmployeeControllerAddDepartmentEmployeeCompensationTypeEnum,
  DepartmentsApi,
} from '../api-client';

const departmentEmployeeApi = new DepartmentEmployeeApi();

export function useDepartments() {
  return useQuery('departments', async () => {
    return new DepartmentsApi()
      .departmentControllerFindDepartment()
      .then((res) => res.data);
  });
}

export function useDepartment(data: { id: string }) {
  return useQuery(['department', data.id], async () => {
    return new DepartmentsApi()
      .departmentControllerFindDepartmentById(data.id)
      .then((res) => res.data);
  });
}

export function useDepartmentEmployees(data: {
  departmentId: string;
  skip: number;
  take: number;
}) {
  return useQuery(['departmentEmployees', data], async () => {
    return new DepartmentEmployeeApi()
      .departmentEmployeeControllerFindDepartmentEmployees(
        data.departmentId,
        data.skip,
        data.take
      )
      .then((res) => res.data);
  });
}

export function useAddDepartmentEmployee() {
  const queryClient = useQueryClient();

  return useMutation(
    ['addDepartmentEmployee'],
    (data: {
      departmentId: string;
      employeeId: string;
      amount: number;
      compensationType: DepartmentEmployeeControllerAddDepartmentEmployeeCompensationTypeEnum;
      defaultHours: number;
    }) => {
      return new DepartmentEmployeeApi().departmentEmployeeControllerAddDepartmentEmployee(
        data.departmentId,
        data.employeeId,
        data.amount,
        data.compensationType,
        data.defaultHours
      );
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries('departmentEmployees');
        queryClient.invalidateQueries('employees');
      },
    }
  );
}

export function useRemoveDepartmentEmployee() {
  const queryClient = useQueryClient();

  return useMutation(
    ['removeDepartmentEmployee'],
    (data: { departmentId: string; employeeId: string }) => {
      return new DepartmentEmployeeApi().departmentEmployeeControllerDeleteDepartmentEmployee(
        data.departmentId,
        data.employeeId
      );
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries('departmentEmployees');
      },
    }
  );
}

export function useUpdateDepartmentEmployee() {
  const queryClient = useQueryClient();

  return useMutation(
    ['updateDepartmentEmployee'],
    (
      args: Parameters<
        typeof departmentEmployeeApi.departmentEmployeeControllerUpdateDepartmentEmployee
      >
    ) => {
      return departmentEmployeeApi.departmentEmployeeControllerUpdateDepartmentEmployee(
        ...args
      );
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries('departmentEmployees');
      },
    }
  );
}
